<h2 mat-dialog-title>{{ is_edit_mode ? 'Editar formación' : 'Nueva formación' }}</h2>

<mat-dialog-content [formGroup]="form">
  <mat-form-field class="w-100">
    <mat-label>Nombre</mat-label>
    <input matInput formControlName="name" />
  </mat-form-field>

  <mat-form-field class="w-100">
    <mat-label>Caducidad (meses)</mat-label>
    <input matInput type="number" formControlName="expiration_in_months" min="1" />
  </mat-form-field>

  <mat-form-field class="w-100">
    <mat-label>Duración estimada (horas)</mat-label>
    <input matInput type="number" formControlName="duration_in_hours" min="1" />
  </mat-form-field>

  <mat-form-field class="w-100">
    <mat-label>URL</mat-label>
    <input matInput formControlName="url" />
  </mat-form-field>

  <mat-form-field class="w-100">
    <mat-label>Skills</mat-label>
    <mat-select formControlName="skill_ids" multiple>
      @for (skill of skills(); track skill.id) {
        <mat-option [value]="skill.id">{{ skill.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()" [disabled]="loading()">Cancelar</button>
  <button mat-flat-button color="accent" type="button" (click)="save()" [disabled]="loading() || form.invalid">Guardar</button>
</mat-dialog-actions>
